<div class="admin-dashboard">
  <mat-toolbar color="primary" class="admin-toolbar">
    <button mat-icon-button (click)="drawer.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <span>Lenali - Administration</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </mat-toolbar>

  <mat-drawer-container class="admin-container">
    <mat-drawer #drawer mode="side" opened>
      <mat-nav-list>
        <a mat-list-item routerLink="/admin/dashboard" routerLinkActive="active">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>Tableau de bord</span>
        </a>
        <a mat-list-item routerLink="/admin/account-deletion-requests" routerLinkActive="active">
          <mat-icon matListItemIcon>delete_forever</mat-icon>
          <span matListItemTitle>Demandes de suppression</span>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/" target="_blank">
          <mat-icon matListItemIcon>public</mat-icon>
          <span matListItemTitle>Voir le site</span>
        </a>
      </mat-nav-list>
    </mat-drawer>

    <mat-drawer-content>
      <div class="content">
        <h1>Demandes de suppression de compte</h1>

        <div class="filter-container">
          <mat-form-field appearance="outline">
            <mat-label>Filtrer par statut</mat-label>
            <mat-select [formControl]="statusFilter">
              <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="isLoading" class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div *ngIf="!isLoading && dataSource.data.length === 0" class="no-data">
          <mat-icon>info</mat-icon>
          <p>Aucune demande de suppression de compte pour le moment</p>
        </div>

        <div *ngIf="!isLoading && dataSource.data.length > 0" class="table-container">
          <table mat-table [dataSource]="dataSource" matSort class="requests-table">
            
            <!-- Date Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
              <td mat-cell *matCellDef="let request"> 
                {{ request.createdAt?.toDate() | date:'dd/MM/yyyy HH:mm' }} 
              </td>
            </ng-container>

            <!-- User Name Column -->
            <ng-container matColumnDef="userName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Utilisateur </th>
              <td mat-cell *matCellDef="let request"> {{ request.userName }} </td>
            </ng-container>

            <!-- User Email Column -->
            <ng-container matColumnDef="userEmail">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
              <td mat-cell *matCellDef="let request"> 
                {{ request.userEmail || request.contactEmail || 'Non disponible' }} 
              </td>
            </ng-container>

            <!-- Reason Column -->
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef> Raison </th>
              <td mat-cell *matCellDef="let request"> {{ request.reason }} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
              <td mat-cell *matCellDef="let request"> 
                <span [ngClass]="'status-' + request.status">
                  {{ getStatusLabel(request.status) }}
                </span>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let request"> 
                <div class="action-buttons">
                  <!-- Boutons d'action selon le statut actuel -->
                  <ng-container [ngSwitch]="request.status">
                    <ng-container *ngSwitchCase="'pending'">
                      <button mat-icon-button color="primary" 
                        [disabled]="processingRequest === request.id"
                        (click)="changeStatus(request.id, 'processing')" 
                        matTooltip="Marquer en cours">
                        <mat-icon>hourglass_top</mat-icon>
                      </button>
                      <button mat-icon-button color="accent" 
                        [disabled]="processingRequest === request.id"
                        (click)="changeStatus(request.id, 'completed')" 
                        matTooltip="Approuver et supprimer">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" 
                        [disabled]="processingRequest === request.id"
                        (click)="changeStatus(request.id, 'rejected')" 
                        matTooltip="Rejeter">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </ng-container>
                    
                    <ng-container *ngSwitchCase="'processing'">
                      <button mat-icon-button color="accent" 
                        [disabled]="processingRequest === request.id"
                        (click)="changeStatus(request.id, 'completed')" 
                        matTooltip="Approuver et supprimer">
                        <mat-icon>check_circle</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" 
                        [disabled]="processingRequest === request.id"
                        (click)="changeStatus(request.id, 'rejected')" 
                        matTooltip="Rejeter">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </ng-container>
                    
                    <ng-container *ngSwitchDefault>
                      <span class="action-completed">Traitement terminé</span>
                    </ng-container>
                  </ng-container>
                  
                  <mat-spinner *ngIf="processingRequest === request.id" 
                    diameter="20" color="accent"></mat-spinner>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
